export function formatDateTime(timestamp, type) {
    if (!timestamp || isNaN(Number(timestamp)) || Number(timestamp) === 0) return "";

    const date = new Date(Number(timestamp) * 1000);
    if (isNaN(date.getTime())) return "";

  // Format the date in IST (UTC+5:30)
  const options = type === "datetime-local"
    ? {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Asia/Kolkata'
      }
    : {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'Asia/Kolkata'
      };

  // Format the date according to the options
  const formattedDate = new Intl.DateTimeFormat('en-CA', options).format(date);

  // For datetime-local, we need to convert from "YYYY-MM-DD, HH:MM" to "YYYY-MM-DDTHH:MM"
  if (type === "datetime-local") {
    return formattedDate.replace(', ', 'T');
  }


  return formattedDate;
} 